import React, { forwardRef } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import Section from 'components/page/Section'
import SubSection from '../SubSection'

import getStarry from 'lib/ui/starry'

import { classString } from 'helpers'

const starry = getStarry({})

const StarContainer = styled.div.attrs({
  className: starry.starClassName,
})`
  max-width: 1266px;
  width: 100vw;
  &&& {
    position: absolute;
  }

  top: 0;
  left: 0;
`

const StarrySection = forwardRef(function (
  { children, className, renderAs = 'Section', ...others },
  ref
) {
  const StarSection = styled(renderAs === 'Section' ? Section : SubSection)`
    &,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
      color: white;
    }
  `
  return (
    <StarSection
      ref={ref}
      className={classString([className, starry.className])}
      {...others}
    >
      <StarContainer>{starry.children}</StarContainer>
      {children}
    </StarSection>
  )
})

export default StarrySection

StarrySection.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  renderAs: PropTypes.oneOf(['Section', 'SubSection']),
}
